<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'ops-overview'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="block sbnbDesktop:hidden">Overview</h2>
        <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'ops-overview'"></sbnb-helptext-wrapper>
      </sbnb-page-header>
      <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'ops-overview'"></sbnb-helptext-wrapper>
    </app-feature-flag-tabs>

    <div
      class="overview__container"
      fxLayout="row"
      fxLayout.lt-lg="column"
      fxLayoutAlign="space-between"
      fxLayoutGap="24px"
      fxHide.lt-md>
      <ng-container *ngIf="counts$ | async as counts">
        <div class="overview__section" fxFlex="32" fxLayout="column" fxLayoutAlign="start start">
          <h4 fxLayout fxLayoutGap="10px">
            <span class="ocean">{{ counts.data.rules }}</span>
            <span>Task rules</span>
          </h4>
          <p class="text__small">
            Create a task rule to automate the creation of jobs in relation with a reservation. Depending on your
            workflow, you can opt to assign manually, or auto-assign.
          </p>
          <button
            [routerLink]="['../task-rules']"
            type="submit"
            mat-flat-button
            class="button__secondary button__small">
            Manage task rules
          </button>
        </div>

        <div class="overview__section" fxFlex="32" fxLayout="column" fxLayoutAlign="start start">
          <h4 fxLayout fxLayoutGap="10px">
            <span class="ocean">{{ counts.data.mates }}</span>
            <span>Teammates</span>
          </h4>
          <p class="text__small">
            Your teammates contribute to the day-to-day of your business. After adding their contact details, they can
            receive notifications and be assigned to tasks.
          </p>
          <button [routerLink]="['../team']" type="submit" mat-flat-button class="button__secondary button__small">
            Manage teammates
          </button>
        </div>

        <div class="overview__section" fxFlex="32" fxLayout="column" fxLayoutAlign="start start">
          <h4 fxLayout fxLayoutGap="10px">
            <span class="ocean">{{ counts.data.notification_rules }}</span>
            <span>Notification rules</span>
          </h4>
          <p class="text__small">
            Send email or SMS notifications to your teammates in relation with the properties they manage. They can also
            receive notifications regarding their task updates.
          </p>
          <button
            [routerLink]="['../notifications']"
            type="submit"
            mat-flat-button
            class="button__secondary button__small">
            Manage notifications
          </button>
        </div>
      </ng-container>
    </div>

    <div *ngIf="perms$.hasAccessTo(Features.PERM_TASKS) | async">
      <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="4px" style="margin-bottom: 16px">
        <span fxFlex>Unassigned tasks</span>

        <button class="button__small mobile__hidden" mat-flat-button [routerLink]="['/calendar/tasks']">
          Task calendar
        </button>
      </h2>

      <ng-container *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
      </ng-container>

      <ng-container *ngIf="unassignedTasks">
        <sbnb-no-items
          *ngIf="unassignedTasks?.length === 0"
          icon="task"
          text="You don't have any unassigned tasks"></sbnb-no-items>

        <div
          *ngFor="let task of unassignedTasks"
          class="ops__overview-item"
          [class.ops__overview-item-soon]="task.urgent"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="16px">
          <div fxHide.lt-md fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <strong [matTooltip]="task.name">{{ task.task_rule ? task.task_rule.name : task.task_type_string }}</strong>

            <span class="overview__effort text__xsmall strong">{{ task.duration }}</span>
          </div>

          <div *ngIf="task.property" fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <img fxFlex="24px 0 0" class="property__image" [src]="task.property.picture" width="24px" height="20px" />
            <span fxFlex class="text__small">{{ task.property.name }}</span>
          </div>

          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon [size]="16" icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span class="text__small" [matTooltip]="task.start_date_tooltip">
              in {{ task.start_date | timeAgo: false }}
            </span>
          </div>

          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="20px">
            <button
              mat-flat-button
              class="button__secondary button__small"
              #assignMenuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="assignMenu"
              (menuOpened)="selectedTask = task">
              Assign
            </button>
            <button
              fxHide.lt-md
              mat-flat-button
              class="button__secondary button__small"
              (click)="deleteTask(task.uuid)">
              Cancel
            </button>
          </div>
        </div>

        <mat-menu #assignMenu="matMenu" class="filters__cdk-menu filters__cdk-menu-320">
          <sbnb-menu-task-assign
            [task]="selectedTask"
            (taskAssigned)="removeTaskFromList(selectedTask.uuid)"
            (closeMenu)="assignMenuTrigger.closeMenu()"></sbnb-menu-task-assign>
        </mat-menu>

        <sbnb-pagination
          *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
          position="end"
          [pageCount]="paginationData.page_numbers.total_pages"
          [currentPage]="paginationData.page_numbers.this_page"
          (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
      </ng-container>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
